// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
const app = angular.module('CustomerSupport', [
  'ngMessages',
  'giRemoting',
  'giSpinner',
  'giTracking',
  'giTranslation',
  'giRecaptcha',
  'templates',
  'giIcons',
  'giMultiBannerBuilder',
  'giCustomerNotifications',
  'giModal',
  'ng-rails-csrf',
]);
